import { EventRsvpsPanel } from "../../../components/admin/event-hub/EventRsvpsPanel";

export function AdminEventRsvpsPage() {
  return <EventRsvpsPanel />;
}
